import { put, select, all } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import projectSelectors from "rdx/modules/projects/selectors";
import adminProjectsSelectors from "rdx/modules/adminProjects/selectors";
import { orgProjectsApi } from "rdx/modules/enterpriseProjects/endpoints";
import messages from "rdx/modules/enterpriseProjects/messages";
import { ORG_PROJECTS_TAGS } from "rdx/modules/enterpriseProjects/tags";

import { camelizeKeys } from "@helpers";

function* submitEnterpriseLeadToSeller(action) {
  const { provider_lead_id, receiver_id, flat_amount, percentage } = action.payload;

  const offer = { receiver_id };
  if (flat_amount) {
    offer.flat_amount = flat_amount;
  } else if (percentage) {
    offer.percentage = percentage;
  }

  const { success, data, error } = yield* makeRequest.post(`/provider_leads/${provider_lead_id}/project_offers`, offer);

  if (success && data) {
    const enterpriseProjectDetail = yield select(projectSelectors.getProjectDetails);

    const adminListProjects = yield select(adminProjectsSelectors.getAdminProjectsList);
    const { projects: adminProjects } = adminListProjects;
    const updatedProject = adminProjects.find((project) => project.id === data.body.project.id);

    if (updatedProject) {
      updatedProject.offer = {
        receiver: { ...data.body.receiver },
        rescindedAt: data.body.rescinded_at,
        responseId: null,
      };
    }
    yield all([
      yield put(orgProjectsApi.util.invalidateTags([ORG_PROJECTS_TAGS.ORG_PRE_SALES_PROJECTS])),
      yield put(
        actions.setProjectDetails({
          ...enterpriseProjectDetail,
          providerLead: {
            ...enterpriseProjectDetail.providerLead,
            offer: camelizeKeys(data.body),
          },
        }),
      ),
      yield put(actions.setAdminProjectsList({ ...adminProjects })),
      put(
        actions.newSuccessEvent({
          message: messages.ENTERPRISE_LEAD_OFFER_SUCCESS,
          payload: camelizeKeys(data.body),
        }),
      ),
    ]);
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_SUBMITTING_ENTERPRISE_LEAD_OFFER,
      // payload: {},
    });
  }

  return null;
}

export default submitEnterpriseLeadToSeller;
